// Dependencies
import React, { useState, useEffect, useRef, useCallback, useContext } from "react";
import { ReactSVG } from "react-svg";
import classNames from 'classnames'
import { CSSTransition } from 'react-transition-group'
import { CSSTransitionProps } from 'react-transition-group/CSSTransition'

// Types
import { Types, Components } from '../types';
 
// Hooks
import { useDebug } from "../hooks";

// Utils
import { getAssetURL } from '../utils/helpers'

const CartIcon = ({icon, quantity, loading = false, className, theme}: any) => {
    useDebug('CartIcon'); 

    const transitionProps: CSSTransitionProps = React.useMemo(() => ({
        timeout: Number(theme.general.transition.duration.replace('ms', '')),
        unmountOnExit: true
      }), [theme.general.transition.duration])

    return ( 
        <div className={className}>
            <ReactSVG 
                className={`${className}--wrapper`}
                src={getAssetURL('icon', 'cart-default')}
            />
            <div className={`${className}--quantity`}>
                <CSSTransition {...transitionProps} in={ loading } >
                    <span className="loading-spinner"></span>
                </CSSTransition>
                <CSSTransition {...transitionProps} in={ ! loading } >
                    <span>{quantity}</span>
                </CSSTransition>
            </div>
        </div>
    )

}

export default CartIcon; 